---
title: الخطة والإضافات والفواتير
parent: المستندات
parentHref: /docs
---

<script>
  import DomainTlds from "@/components/domain-tlds.svelte"
</script>

# الخطة والإضافات والفواتير والصفحات القانونية

## خطة واحدة تشمل كل شيء

يقدم TOBY خطة واحدة شاملة بدون رسوم إعداد ولا مستويات خفية:

- **فوترة شهرية أو سنوية:** اختر الفوترة الشهرية المرنة (يمكن إلغاؤها شهرياً في أي وقت) أو الفوترة السنوية المخفضة (يمكن دفعها أيضاً بموجب فاتورة). راجع [قائمة الأسعار](/ar/pricing) للاطلاع على الأسعار الحالية.

كل اشتراك يتضمن:

- **نطاق خاص بك** (<DomainTlds />) — بما في ذلك نقل نطاق موجود (Domain-Umzug)
- **عنوان بريد إلكتروني واحد** (info@...) مع **صندوق بريد 15 GB (Maxi-Postfach)** وعناوين إعادة توجيه غير محدودة
- **حتى 15 صفحة** — تُنشأ وتُدار عبر المحادثة أو الصوت أو تحميل الصور
- **لغة إضافية واحدة** (لغتان إجمالاً) مع ترجمة تلقائية عند النشر
- **رسالة إخبارية** مع **1,000 بريد إلكتروني / شهر**
- **تحليلات الزوار** (صديقة للخصوصية، بدون لافتات ملفات تعريف الارتباط)
- **حزمة البداية بالبريد** (ملصق الباب وحامل QR بحجم A5 للطاولة)
- **الاستضافة في الاتحاد الأوروبي** مع أمان SSL تلقائي

## إضافات اختيارية

إذا نما نشاطك التجاري بما يتجاوز الحدود المضمنة، يمكنك إضافة وحدات مرنة في أي وقت ضمن **الإعدادات ← الاشتراك** (يمكن إلغاؤها شهرياً، راجع [قائمة الأسعار](/ar/pricing)):

- **+15 GB مساحة تخزين البريد الإلكتروني** (أو صندوق بريد إضافي)
- **+لغة إضافية واحدة للموقع**
- **+15 صفحة إضافية**
- **+5,000 بريد إلكتروني للرسالة الإخبارية / شهر**

## الحصول على فاتورة تجارية رسمية (الموقع الإلكتروني مقابل Google Play)

إذا كنت تدير نشاطاً تجارياً أو عيادة أو حساب عمل حر وتحتاج إلى **فاتورة تجارية رسمية قابلة للخصم الضريبي (ordentliche Rechnung)** تتضمن اسم شركتك وعنوان العمل وضريبة القيمة المضافة (MwSt.) موضحة بشكل منفصل، يرجى ملاحظة مكان الاشتراك:

- **الاشتراك عبر الموقع الإلكتروني (tobysite.com عبر Stripe):** ستتلقى دائماً **فاتورة تجارية رسمية تتضمن ضريبة القيمة المضافة** منا، موجهة إلى نشاطك التجاري. يمكنك تنزيل جميع الفواتير السابقة وتحديث عنوان الفوترة لشركتك في أي وقت ضمن **الإعدادات ← الاشتراك**.
- **الاشتراك عبر تطبيق Android (الشراء داخل التطبيق من Google Play):** عند الاشتراك عبر Google Play، تقوم Google بمعالجة الدفع كتاجر مسجل وتصدر فقط إيصال دفع Google Play القياسي. **لا يمكننا إصدار فاتورة تجارية رسمية تتضمن ضريبة القيمة المضافة (ordentliche Rechnung) للاشتراكات التي تُفوتر عبر Google Play.**

> **نصيحة:** يمكنك الاشتراك عبر **tobysite.com** في متصفحك للحصول على فواتير Stripe التجارية الرسمية ومع ذلك استخدام تطبيقات TOBY لنظامي Android و iOS مع حسابك دون تكلفة إضافية.

## إضافة بيانات المعلومات (Impressum) وسياسة الخصوصية (Datenschutz)

- **نصك القانوني الخاص:** نظراً لأن المتطلبات القانونية تعتمد على هيكل نشاطك التجاري ومهنتك وبلدك، **لا يقدم TOBY استشارات قانونية أو يكتب نصوصاً قانونية (Impressum أو Datenschutzerklärung) بنفسه.**
- **كيفية إضافتها:** ببساطة الصق نص بيانات المعلومات أو سياسة الخصوصية الموجود لديك في المحادثة (أو قم بتحميله كمستند Word/PDF، أو اطلب من TOBY نسخه من موقعك القديم) وقل *"ضع هذا في صفحة بيانات المعلومات."* سيقوم TOBY بإنشاء الصفحات وربطها بشكل منظم في تذييل موقعك.
